<app-form-select
  [formControl]="formControl"
  [valueField]="'code'"
  [data]="items$ | async"
  [loading]="loading$ | async"
  [showOutOfScopeValue]="showOutOfScopeValue"
  (itemSelected)="itemSelected.emit($event)"
  [label]="label"></app-form-select>
